import Vue from 'vue'

export async function login(context, [username, password]) {
    try {
        context.commit('setLoading', true, { root: true })
        const response = await Vue.axios({
            method: 'POST',
            url: '/loginmeigasgest',
            headers: {
                'Accept' : 'application/json',
                'Content-Type': 'application/json',
            },
            data: {
                username,
                password,
            }
        })
        context.commit('auth/setAccessToken', response.data.access_token, { root: true })
        context.commit('auth/setUser', response.data.user, { root: true })
    } catch (e) {
        context.commit('auth/authError', e.message, { root: true })
    } finally {
        context.commit('setLoading', false, { root: true })
    }
}


export async function logOut(context, [access_token]) {
    try {
        if (access_token) {
           
            const response = await Vue.axios({
                method: 'POST',
                url: '/logout',
                headers: {
                  //  'Access-Control-Allow-Methods': 'GET,PUT,POST,DELETE,PATCH,OPTIONS',
                    'Content-Type': 'application/json',
                    'Accept': 'application/json',
                    'Authorization': 'Bearer ' + access_token,
                },
            })
            
            context.commit('auth/logout', null, { root: true })
        }

    } catch (e) {
        context.commit('auth/authError', e.message, { root: true })
    } finally {
      
    }
}

export async function getInitialData(context, [access_token]) {
    try {
        if (access_token) {
            const response = await Vue.axios({
                method: 'GET',
                url: '/getInitialData',
                headers: {
                    'Content-Type': 'application/json',
                    'Accept': 'application/json',
                    'Authorization': 'Bearer ' + access_token,
                },
            })
            
            context.commit('estados/setEstados', response.data.estados, { root: true })
            context.commit('auth/setMasterProveedores', response.data.master_proveedores, { root: true })
        }

    } catch (e) {
        context.commit('auth/authError', e.message, { root: true })
    } finally {
      
    }
}




